import { useModalContext } from "../contexts/ModalContext"
import HeaderShadowSeparator from "../components/parts/separator/HeaderShadowSeparator"
import PagesHeader from "../components/header/pagesHeader/PagesHeader"
import Modal from "../components/modal/Modal"
import avatar from "../assets/images/avatar.png"
import OpenProfileModalButton from "../components/profile/OpenProfileModalButton"

const ProfilePage = () => {
  const { modalState } = useModalContext()

  const headerContent = <>
    <div className="flex justify-between items-center w-full">
      <div className="h-[10vh] w-1/3 flex justify-start">
        <img className="max-h-full rounded-full" src={avatar} alt="avatar" />
      </div>
      <h1 className="pagesHeader-title">Mon profil</h1>
      <div className="w-1/3 flex justify-end">
        <OpenProfileModalButton />
      </div>
    </div>
  </>

  const sections = ['Mon anniversaire', 'Statistiques', "Événements récents"]
  const btnArray = sections.map(section =>
    <div key={section} className="min-h-[10vh] card cursor-pointer">
      <h2>{section}</h2>
    </div>
  )

  return (
    <main className="main-logged">
      <HeaderShadowSeparator css="bg-ivory" />
      <PagesHeader child={headerContent} />
      <div className="h-[50vh] w-full overflow-y-auto global-px py-3 flex flex-col gap-4 rounded-md font-bold text-darkOrange md:h-[53vh] md:grid md:auto-rows-min md:grid-cols-2 lg:h-[63vh] lg:grid-cols-3">
        {btnArray}
      </div>
      {modalState.modalType === "profile" && <Modal
        typeModal={modalState.modalType}
        imgHeader={[avatar, "avatar"]}
        headerTitle={'Mes informations'}
      />}
    </main>
  )
}
export default ProfilePage